import { Divider, Stack } from "@mui/material";
import { isSameYear } from "date-fns";
import React, { useState } from "react";
// import { YearMonthRange } from ".";
import MonthCalendar from "./MonthPicker";

const MonthRangePicker = ({ dateFormater, value, onChange }) => {
	const [rightLastSet, setRightLastSet] = useState(false);

	const leftYear = value[0];
	const rightYear = value[1];
	const sameYear = isSameYear(leftYear, rightYear);

	return (
		<Stack direction="row" justifyContent="center">
			{sameYear ? (
				<MonthCalendar
					value={value}
					dateFormater={dateFormater}
					year={leftYear}
					onChange={(v) => {
						if (!rightLastSet) {
							if (v <= rightYear) {
								onChange([v, rightYear]);
								setRightLastSet(true);
							} else {
								onChange([leftYear, v]);
								setRightLastSet(false);
							}
						} else if (v >= leftYear) {
							onChange([leftYear, v]);
							setRightLastSet(false);
						} else {
							onChange([v, leftYear]);
							setRightLastSet(true);
						}
					}}
				/>
			) : (
				<>
					<MonthCalendar
						value={value}
						dateFormater={dateFormater}
						year={leftYear}
						onChange={(startMonth) => {
							onChange([startMonth, rightYear]);
						}}
					/>
					<Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
					<MonthCalendar
						value={value}
						dateFormater={dateFormater}
						year={rightYear}
						onChange={(endMonth) => {
							onChange([leftYear, endMonth]);
						}}
					/>
				</>
			)}
		</Stack>
	);
};

export default MonthRangePicker;
